import loadable from '@loadable/component';

import { BoxIndicator } from '@classtinginc/design-system';

const LearningCardViewerPage = loadable(
  () => import('./LearningCardViewerPage'),
  {
    fallback: <BoxIndicator data-testid="learning_viewer_page_loading" />,
  }
);

export default LearningCardViewerPage;
